import { createReducer } from 'typesafe-actions';
import { setCollapseSidebar, setShowSecondBurger, setShowSidebar, toggleSideMenu } from './actions';

export type ICommonState = Readonly<{
  showNavbar: boolean;
  showSecondBurger: boolean;
  showSidebar: boolean;
  collapseSidebar: boolean;
}>;

/* ------------- Initial State ------------- */
const initialState: ICommonState = {
  showNavbar: true,
  showSecondBurger: false,
  showSidebar: false,
  collapseSidebar: false,
};

export default createReducer(initialState)
  /* ------------- setShowSidebar ------------- */
  .handleAction(setShowSidebar, (state, action) => ({
    ...state,
    showSidebar: action.payload,
  }))
  /* ------------- setCollapseSidebar ------------- */
  .handleAction(setCollapseSidebar, (state, action) => ({
    ...state,
    collapseSidebar: action.payload,
  }))
  /* ------------- setShowSecondBurger ------------- */
  .handleAction(setShowSecondBurger, (state, action) => ({
    ...state,
    showSecondBurger: action.payload,
  }))
  .handleAction(toggleSideMenu, state => ({
    ...state,
    collapseSidebar: !state.collapseSidebar,
  }));
